import Vue from 'vue'
import Router from 'vue-router'
import routes from './routes'
import store from '@/store'
import storage from '@/modules/storage'
import { isObject } from 'lodash'

Vue.use(Router)

const router = new Router({
  linkActiveClass : 'open active',
  scrollBehavior  : () => ({ y : 0 }),
  routes          : routes,
  mode            : 'history',
  base            : '/'
})

const checkOnboardingProcessHasCompleted = (next, to) => {
  if (process.env.APP_THEME === 'epicor') {
    return true;
  }

  const { appData, companyId } = store.state.app.User

  if (isObject(appData) && appData.needsEmployeesSetup && companyId && !to.path.match('employeesetup')) {
    window.location.href = "/signup/employeesetup"
    next()
  }
}


router.beforeEach(async (to, from, next) => {
  if(to.meta.isGuest){
    await store.dispatch('app/checkLogin')
    if(store.getters['app/isAuthenticated'] && to.meta.isGuestOnly){
      window.location.href = '/dashboard'
      next('/dashboard')
      return 
    }
    next()
    return
  }
  
  store.dispatch('app/loadApp')
    .finally(()=>{
      if(store.getters['app/isAuthenticated'] && store.getters['app/appLoaded']){
        checkOnboardingProcessHasCompleted(next, to)
        next()
        return 
      } else{
        next('/site/login')
        
        return storage.removeAll()
      }
    })
})


export default router
